// This file is generated by pnpm icons:generate. Do not edit.

import {PageX_Stroke2_Corner0_Rounded_Large as CanonicalPageX_Stroke2_Corner0_Rounded_Large} from './Page'

/** @deprecated Import PageX_Stroke2_Corner0_Rounded_Large from `#/components/icons/Page` instead. */
export const PageX_Stroke2_Corner0_Rounded_Large =
  CanonicalPageX_Stroke2_Corner0_Rounded_Large
